
namespace Gamification.Gamification {
    export class ApiComandiColumns {
        static columnsKey = 'Gamification.ApiComandi';
    }
}